<template>
  <a
    href="https://www.ucari.com/discount/WELLNESS20?redirect=/collections/all"
    target="_blank"
    rel="noopener noreferrer"
    class="ucari-promo"
  >
    <img src="/images/wellness-20-2.jpg" alt="Use code WELLNESS20 to get 20% off an additional intolerance test kit.">
  </a>
</template>

<style scoped>
.ucari-promo {
  display: block;
  height: 100%;
  min-height: 138px;
  border-radius: 20px;
  overflow: hidden;
  box-shadow: 0 10px 24px rgba(15, 38, 95, 0.08);
}

.ucari-promo img {
  display: block;
  width: 100%;
  height: 100%;
  object-fit: cover;
}

@media (max-width: 639px) {
  .ucari-promo {
    min-height: 120px;
    border-radius: 16px;
  }
}
</style>